module.exports = __webpack_public_path__ + "img/truckloans-white-text-only-powered.24c18c23.png";